import { useCallback, useEffect, useState } from 'react'
import { League } from 'types/leagues'
import { useParams } from 'react-router-dom'
import { getLeagueById } from 'services/leagues'
import { LeagueScorerTable } from '../../../components/league-scorer-table'
import { Scorer } from 'types/roster'
import { getLeagueScorerTable } from 'services/roster'

export const ScorerTable = () => {
    const { league: leagueId } = useParams()

    const [league, setLeague] = useState<League>()
    const [scorerTable, setScorerTable] = useState<Scorer[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    const getLeagueInfo = useCallback(() => {
        setLoading(true)
        getLeagueById(Number(leagueId))
            .then(setLeague)
            .finally(() => {
                setLoading(false)
            })
    }, [leagueId])

    const getScoreTableData = useCallback(() => {
        getLeagueScorerTable(Number(leagueId)).then(setScorerTable)
    }, [leagueId])

    useEffect(() => {
        getLeagueInfo()
        getScoreTableData()
    }, [getLeagueInfo, getScoreTableData])

    return (
        <div>
            League: {league?.name}. Scorer table
            <LeagueScorerTable data={scorerTable} loading={loading} />
        </div>
    )
}
